import { useState } from 'react'
import PropTypes from 'prop-types'

import {
  Box,
  Icon,
  Label,
  MotionBox,
  TransparentButton,
  Text,
} from '@redriverpress/system'

const motionVariants = {
  open: {
    height: 'auto',
    opacity: 1,
    overflow: 'visible',
  },
  closed: {
    height: 0,
    opacity: 0,
    overflow: 'hidden',
  },
}

export default function TeacherDiscretion({ discretionText, ...props }) {
  const [isInfoOpen, setIsInfoOpen] = useState(false)

  return (
    <Label
      width={discretionText && '100%'}
      textAlign='left'
      type='warning'
      compact={!!discretionText}
      {...props}
    >
      {discretionText ? (
        <>
          <TransparentButton
            width={1}
            onClick={() => setIsInfoOpen(!isInfoOpen)}
            display='flex'
            alignItems='center'
            justifyContent='space-between'
            px={0}
          >
            <Box display='flex' justifyContent='center' alignItems='center'>
              <Icon icon='exclamation-triangle' pr={2} />
              <Text fontWeight='600'>Teacher discretion</Text>
            </Box>
            <Icon icon={isInfoOpen ? 'chevron-up' : 'chevron-down'} />
          </TransparentButton>
          <MotionBox
            mx={-1}
            px={1}
            variants={motionVariants}
            animate={isInfoOpen ? 'open' : 'closed'}
            initial={false}
          >
            <Box fontWeight='400' pt={3}>
              {discretionText}
            </Box>
          </MotionBox>
        </>
      ) : (
        <Box display='flex' justifyContent='center' alignItems='center'>
          <Icon icon='exclamation-triangle' pr={2} />
          <Text fontWeight='600'>Teacher discretion</Text>
        </Box>
      )}
    </Label>
  )
}

TeacherDiscretion.defaultProps = {
  discretionText: null,
}

TeacherDiscretion.propTypes = {
  discretionText: PropTypes.string,
}
